import React from 'react'
import { AlertTriangle, CheckCircle, Info, AlertCircle } from 'lucide-react'
import { cn } from '../../lib/utils'

const ValidationMessage = ({ 
  type = 'error', 
  message, 
  className,
  showIcon = true,
  size = 'sm'
}) => {
  if (!message) return null

  const icons = {
    error: AlertTriangle,
    warning: AlertCircle,
    success: CheckCircle,
    info: Info
  }

  const styles = {
    error: 'text-red-600 bg-red-50 border-red-200',
    warning: 'text-yellow-600 bg-yellow-50 border-yellow-200',
    success: 'text-green-600 bg-green-50 border-green-200',
    info: 'text-blue-600 bg-blue-50 border-blue-200'
  }

  const sizes = {
    xs: 'text-xs p-1',
    sm: 'text-sm p-2',
    md: 'text-base p-3'
  }

  const Icon = icons[type]

  return (
    <div className={cn(
      'flex items-start space-x-2 rounded-md border',
      styles[type],
      sizes[size],
      className
    )}>
      {showIcon && Icon && (
        <Icon className={cn(
          'flex-shrink-0 mt-0.5',
          size === 'xs' ? 'h-3 w-3' : size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'
        )} />
      )}
      <span className="flex-1">{message}</span>
    </div>
  )
}

export default ValidationMessage